// extracted by mini-css-extract-plugin
export default {"burgerButton":"root_burger-button-module__burgerButton___wjhX1"};